import _ from 'lodash';
import React from 'react';
import {submit, isSubmitting} from 'redux-form';

import {default as Modal, withModal} from 'components/Modal';
import Button from 'components/Button';

import {noOpAction} from 'ducks';
import {MODALS, fetchTeamPermissions} from 'ducks/teams';
import {selectModal} from 'ducks/modals';
import {userProfileRequest, selectCurrentUser} from 'ducks/auth';

import {ManageTeamPermissionsForm} from './components';

import './styles.css';

class ManageTeamPermissionsModal extends React.Component<any> {
  componentDidMount() {
    this.props.fetchTeamPermissions(
      {teamId: this.props.data.teamId},
      this.props.storeDataExtraActions(data => ({teamPermissions: data}))
    );
  }

  triggerFormSubmit = () => {
    this.props.submit('manageTeamPermissions');
  };

  getSubmitExtraActions = () => {
    // Refetch current user if permissions in one of his teams are changed
    let refetchCurrentUser = noOpAction;

    const {members, currentUser} = this.props.data;
    if (!_.isNil(members)) {
      if (members.map(m => m.id).includes(currentUser.id)) {
        refetchCurrentUser = () => userProfileRequest();
      }
    }

    return [...this.props.closeModalExtraActions, refetchCurrentUser];
  };

  render() {
    const {closeModal, submitting, data: {teamId}} = this.props;

    return (
      <Modal
        className="ManageTeamPermissionsModal"
        type={Modal.MEDIUM}
        show={true}
        onClose={closeModal}>
        <Modal.Header heading="Manage Permission" />
        <Modal.Body>
          <ManageTeamPermissionsForm
            getSubmitExtraActions={this.getSubmitExtraActions}
            teamId={teamId}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button white onClick={closeModal}>
            Cancel
          </Button>
          <Button
            onClick={this.triggerFormSubmit}
            blue={!submitting}
            isLoading={submitting}
            disabled={submitting}>
            Save
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToProps = state => {
  const {data: {team}} = selectModal(state, MODALS.TEAM_DETAILS);

  return {
    members: _.get(team, 'members'),
    currentUser: selectCurrentUser(state),
    submitting: isSubmitting('manageTeamPermissions')(state)
  };
};

const mapDispatchToProps = {fetchTeamPermissions, submit};

export default withModal(
  MODALS.MANAGE_TEAM_PERMISSIONS,
  mapStateToProps,
  mapDispatchToProps
)(ManageTeamPermissionsModal);
